export default __webpack_public_path__ + "static/media/vivabonito1.4f0ed786.jpg";